var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dg-column',{attrs:{"gap":"xs","grow":true}},[_c('dg-text',{attrs:{"font-type":_vm.informative ? 'body-highlighted' : 'body'}},[_vm._v(_vm._s(_vm.label))]),_c('dg-text',{attrs:{"font-type":_vm.informative ? 'body' : 'body-highlighted'}},[_vm._v(_vm._s(_vm.value))]),_c('dg-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }